import { StyleXSheet } from "./StyleXSheet";
import { X1StyleXDarkTheme } from "./X1StyleXDarkTheme";
import { X1StyleXDefaultTheme } from "./X1StyleXDefaultTheme";

class _X1StyleXSheet extends StyleXSheet {
  constructor() {
    super({
      rootTheme: X1StyleXDefaultTheme,
      rootDarkTheme: X1StyleXDarkTheme,
    });
  }
}

export const X1StyleXSheet = {
  rootStyleSheet: new _X1StyleXSheet(),
};
